import { useState } from "react";
import { api } from "../../../../../../../../utility/api";

export const ReporteMensualApi = () => {
    const [cargando, setCargando] = useState(false);

    const getTrasladosReporteMensual = async (params) => {
        try {
            setCargando(true);
            const response = await api.get(
                "traslados_reportes/mensual",
                params,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const obtenerReporteMensualExcel = async (params) => {
        setCargando(true);

        const query = new URLSearchParams(params).toString();

        const endpoint = `/api/traslados_reportes/mensual-excel${query ? `?${query}` : ""}`;

        try {
            const response = await fetch(endpoint, {
                method: "GET",
                headers: {
                    Authorization: `Token ${localStorage.getItem("token")}`,
                },
            });

            if (!response.ok) {
                // intentar obtener error real del backend
                let errorData;
                try {
                    errorData = await response.json();
                } catch (error) {
                    errorData = { detail: `Error HTTP ${response.status}` };
                }

                throw errorData;
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            a.download = "traslados_mensual.xlsx";
            a.click();
        } catch (error) {
            console.error("Error al obtener reporte Excel mensual:", error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getTrasladosReporteMensual,
        obtenerReporteMensualExcel,
        
        cargando,
    };
};
